import SliceNames from '@/state/enum';
import addComponentsAction from '@/state/selectors/exposer/add-components';
import { ExposerState } from '@/state/slices/exposer/typings';

class ExposerServiceClass {
	private static _instance: ExposerServiceClass;
	private stores: {
		[key: string]: any;
		zustand?: ExposerState[SliceNames.EXPOSER]['store'];
	} = {};
	private components: Record<string, any> = {};
	private addingComponentsTimeout: ReturnType<typeof setTimeout> | null =
		null;

	constructor() {
		this.expose = this.expose.bind(this);
		this.addComponents = this.addComponents.bind(this);
	}

	public static get instance(): ExposerServiceClass {
		if (!ExposerServiceClass._instance) {
			ExposerServiceClass._instance = new ExposerServiceClass();
			ExposerServiceClass.exposeItself();
		}

		return ExposerServiceClass._instance;
	}

	private static exposeItself() {
		if (!globalThis.dx) globalThis.dx = {};
		globalThis.dx.exposer = ExposerServiceClass.instance;
	}

	public expose<T extends keyof ExposerState[SliceNames.EXPOSER]>(
		type: T,
		key: string,
		value: any,
	) {
		if (!globalThis.dx) globalThis.dx = {};
		globalThis.dx = {
			...globalThis.dx,
			[type]: {
				...globalThis.dx[type],
				[key]: value,
			},
		};

		if (type === 'components') {
			this.addComponents({ [key]: value });
		} else if (type === 'store') {
			this.stores.zustand = globalThis.dx.store?.zustand;
		}
	}

	private addComponents(
		components: ExposerState[SliceNames.EXPOSER]['components'],
	) {
		this.components = {
			...this.components,
			...components,
		};
		if (this.addingComponentsTimeout)
			clearTimeout(this.addingComponentsTimeout);

		this.addingComponentsTimeout = setTimeout(() => {
			if (this.stores.zustand) {
				const addComponents = addComponentsAction(
					this.stores.zustand.getState(),
				);
				addComponents(components);
			}
		}, 600);
	}
}

const ExposerService = ExposerServiceClass.instance;

export { ExposerServiceClass };
export default ExposerService;
